"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var KeyCodes_1 = require("../../utils/KeyCodes");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

require("./colorPicker.scss");

var authoring_common_1 = require("authoring-common");

var ColorUtil_1 = __importDefault(require("../../utils/ColorUtil"));

var colorPickerClassName = 'vis-cf-colorPicker';
var uniqueId = ca_ui_toolkit_1.lodash.uniqueId;

var ColorPickerComponent =
/** @class */
function (_super) {
  __extends(ColorPickerComponent, _super);

  function ColorPickerComponent(props, state) {
    var _this = _super.call(this, props, state) || this;

    _this.state = __assign({}, ColorPickerComponent.defaultProps);
    _this.triggerButton = react_1.default.createRef();
    _this.attachRef = react_1.default.createRef();
    return _this;
  }

  ColorPickerComponent.prototype.componentDidMount = function () {
    var colorPickerModel = this.props.colorPickerModel;
    colorPickerModel.loadColors();
  };

  ColorPickerComponent.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        colorFlyoutOpen = _a.colorFlyoutOpen,
        customColorDialogOpen = _a.customColorDialogOpen;
    var _b = this.props,
        selectedColor = _b.selectedColor,
        className = _b.className,
        style = _b.style,
        flyoutExtraOptions = _b.flyoutExtraOptions;
    var orientation = this.props.orientation;

    if (typeof orientation === 'undefined') {
      orientation = document.body.dir === 'rtl' ? 'bottomLeft' : 'bottomRight';
    }

    return react_1.default.createElement("div", {
      className: colorPickerClassName + " " + className,
      ref: this.attachRef,
      style: style
    }, customColorDialogOpen && this._renderCustomColor(), react_1.default.createElement(ca_ui_toolkit_1.Button, {
      ref: this.triggerButton,
      tabIndex: 0,
      variant: 'frameless',
      onClick: function onClick() {
        _this.setState({
          colorFlyoutOpen: !colorFlyoutOpen
        });
      },
      style: selectedColor && ColorUtil_1.default.getColorStyle(selectedColor.color, selectedColor.fill, selectedColor.pattern),
      className: colorPickerClassName + "_button"
    }), colorFlyoutOpen && react_1.default.createElement(ca_ui_toolkit_1.Flyout, __assign({
      id: uniqueId(colorPickerClassName) + "__flyout",
      "data-tid": uniqueId(colorPickerClassName) + "__flyout"
    }, flyoutExtraOptions, {
      "aria-hidden": colorFlyoutOpen,
      placement: orientation,
      domNodeToAttachTo: this.attachRef.current,
      hideArrow: true,
      offset: 2,
      onClose: this._handleClose.bind(this),
      className: colorPickerClassName + "__flyout"
    }), this._displayFlyout()));
  };

  ColorPickerComponent.prototype._displayFlyout = function () {
    var _a = this.props,
        colorPickerModel = _a.colorPickerModel,
        hasDefaultFillColor = _a.hasDefaultFillColor,
        useSystemPalettes = _a.useSystemPalettes;
    var paletteColors = useSystemPalettes ? colorPickerModel.getSystemPaletteColors() : colorPickerModel.getPaletteColors(hasDefaultFillColor);
    var favoriteColors = colorPickerModel.getFavoriteColors();
    return react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'column',
      className: 'vis-cf-colorPickerContainer'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-paletteColorContainer',
      tabIndex: 0
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'column'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, null, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFormattingPaletteColors'),
      className: 'vis-cf-paletteColorLabel'
    })), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-paletteColorOptions'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      className: 'vis-cf-ColorOptionsContainer'
    }, paletteColors.map(this._displayColors.bind(this, 'paletteColor')))))), favoriteColors.length > 1 && react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-favoriteColorContainer',
      tabIndex: 0
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'column'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, null, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFormattingFavoriteColors'),
      className: 'vis-cf-favoriteColorLabel'
    })), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-favoriteColorOptions'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      className: 'vis-cf-ColorOptionsContainer'
    }, favoriteColors.map(this._displayColors.bind(this, 'favoriteColor')))))), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-customColorContainer',
      tabIndex: 0
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      className: 'vis-cf-customColor',
      label: StringResources_1.default.get('conditionalFormattingCustomColor'),
      onClick: this._showCustomColor.bind(this, true)
    })));
  };

  ColorPickerComponent.prototype._displayColors = function (colorType, color, index) {
    var _this = this;

    var style = {};

    if (color) {
      style = ColorUtil_1.default.getColorStyle(color.color, color.fill || color, color.pattern);

      if (style && !color.pattern) {
        style.background = style.backgroundColor;
      }
    }

    return react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: colorPickerClassName + "-" + colorType + "__colorOptions",
      style: color && style,
      key: index,
      tabIndex: 0,
      "datat-index": index,
      "data-value": color && (color.pattern || color.color || color),
      onClick: this._handleSelect.bind(this, color, colorType),
      onKeyDown: function onKeyDown(e) {
        return _this._handleKey(e, color, colorType);
      }
    });
  };

  ColorPickerComponent.prototype._handleClose = function () {
    var customColorDialogOpen = this.state.customColorDialogOpen; // hide this if the color dialog isn't open

    if (!customColorDialogOpen) {
      this.setState({
        colorFlyoutOpen: false
      });
    }
  };
  /**
   * show/hide the custom colour dialog
   * @param show shows the palette dialog if true
   */


  ColorPickerComponent.prototype._showCustomColor = function (show) {
    this.setState({
      customColorDialogOpen: show
    });
  };

  ColorPickerComponent.prototype._renderCustomColor = function () {
    var uiContext = this.props.uiContext;
    return react_1.default.createElement(authoring_common_1.CustomColorDialog, {
      key: 'colorDialog',
      paletteService: uiContext.getPaletteService(),
      isDialogOpen: true,
      paletteType: 'ConditionalPalette',
      onChange: this._handleSelect.bind(this),
      onCloseDialog: this._showCustomColor.bind(this, false)
    });
  };

  ColorPickerComponent.prototype._handleSelect = function (color, colorType) {
    this.props.onColorSelected(color, colorType);
    this.setState({
      colorFlyoutOpen: false
    });
  };

  ColorPickerComponent.prototype._handleKey = function (e, color, colorType) {
    if (e.keyCode === KeyCodes_1.KeyCodes.ENTER || e.keyCode === KeyCodes_1.KeyCodes.SPACE) {
      this._handleSelect(color, colorType);

      e.preventDefault();
    }
  };

  ColorPickerComponent.defaultProps = {
    colorFlyoutOpen: false,
    customColorDialogOpen: false,
    hasDefaultFillColor: false
  };
  return ColorPickerComponent;
}(react_1.Component);

exports.default = mobx_react_1.observer(ColorPickerComponent);
